import React, { useState } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    
    return ( 
    <Navbar color="light" light expand="md" style={{position: 'fixed', width:'100%', top: 0, zIndex: 1000}}>
        <NavbarBrand href="/">LOGO</NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>       
            <Nav className="ml-auto" navbar>   
                <NavItem>
                    <NavLink href='/#home'>Home</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink href='/#about'>About</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink href='/#products'>Products</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink href='/#solutions'>Solutions</NavLink>
                </NavItem> 
                <NavItem>
                    <NavLink href='/#contact'>Contact</NavLink>
                </NavItem>                       
            </Nav>
        </Collapse>
    </Navbar>
    )
}

export default Header;